/**
 * Sign-in / sign-up failure → the `auth.errors.*` key to show. The same
 * mapping the login page has always used, kept in one testable place.
 */
import { ApiError } from "@/lib/api";

export type AuthErrorKey =
  | "auth.errors.rateLimited"
  | "auth.errors.badCredentials"
  | "auth.errors.disabled"
  | "auth.errors.emailTaken"
  | "auth.errors.weakPassword"
  | "auth.errors.server"
  | "auth.errors.network";

export function authErrorKey(err: unknown): AuthErrorKey {
  if (!(err instanceof ApiError)) return "auth.errors.network";
  switch (err.status) {
    case 429:
      return "auth.errors.rateLimited";
    case 401:
      return "auth.errors.badCredentials";
    case 403:
      return "auth.errors.disabled";
    case 409:
      return "auth.errors.emailTaken";
    case 400:
      return "auth.errors.weakPassword";
    default:
      return "auth.errors.server";
  }
}
